import moment from 'moment'

export const findEntry = (id, data) => {
    const idx = data.findIndex(entry => entry.id === id)
    return idx > -1 ? data[idx] : undefined
}

export const sanitizeDateValue = (input) => {
    let initialValue = input
    if (initialValue !== null && initialValue !== undefined && initialValue !== '' && moment(initialValue) !== 'Invalid Date') {
        return moment(initialValue).toDate()
    }
    return null
}

export const formatDateValue = (input) => {
    let initialValue = input
    if (initialValue !== null && initialValue !== undefined && initialValue !== '' && moment(initialValue) !== 'Invalid Date') {
        return moment(initialValue).utc().format('DD.MM.YYYY')
    }
    return ''
}

export const formatTimeValue = (input) => {
    let initialValue = input
    if (initialValue !== null && initialValue !== undefined && initialValue !== '' && moment(initialValue) !== 'Invalid Date') {
        return moment(initialValue).utc(true).format('HH:mm')
    }
    return ''
}

const currencyFormatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
})

export const formatCurrency = (input) => currencyFormatter.format(input)



// WEBPACK FOOTER //
// ./src/utils/index.js